"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateReceivableStats = void 0;
const common_1 = require("@finley-technologies/common");
const generateReceivableStats = (receivables) => {
    // market value -> advanceRate -> pre-allocation lendable value -> allocation -> post-allocation lendable value
    let totalMarketValue = 0;
    let totalPreAllocationLendableValue = 0;
    let totalPostAllocationLendableValue = 0;
    const uniqueFinleyIds = new Set();
    receivables.forEach((receivable) => {
        const baseFields = receivable.receivableReponseTapeRow.baseFields;
        if (!uniqueFinleyIds.has(baseFields.finley_receivable_id)) {
            totalMarketValue +=
                receivable.receivableReponseTapeRow.requiredIntermediateFields.exposure;
            totalPreAllocationLendableValue +=
                baseFields.pre_allocation_lendable_value;
            uniqueFinleyIds.add(baseFields.finley_receivable_id);
        }
        // post valuation (allocation)
        totalPostAllocationLendableValue +=
            baseFields.post_allocation_lendable_value;
    });
    const effectiveAdvanceRate = common_1.utils.divideByOrZero(totalPreAllocationLendableValue, totalMarketValue);
    const effectiveAllocationRate = common_1.utils.divideByOrZero(totalPostAllocationLendableValue, totalPreAllocationLendableValue);
    return {
        totalMarketValue,
        effectiveAdvanceRate,
        totalPreAllocationLendableValue,
        effectiveAllocationRate,
        totalPostAllocationLendableValue,
    };
};
exports.generateReceivableStats = generateReceivableStats;
//# sourceMappingURL=generateReceivableStats.js.map